<template>
    <div class="searchCert flex align-cen">
        <div class="searchForm" v-if="!isCert">
            <div class="searchForm-item flex align-cen">
                <div class="label">证书编号：</div>
                <div class="inpt">
                    <el-input
                        placeholder="请输入证书编号"
                        v-model="serch"
                        >
                    </el-input>
                </div>
            </div>
             <div class="searchForm-item flex align-cen">
                <div class="label">姓名：</div>
                <div class="inpt">
                    <el-input
                        placeholder="请输入姓名"
                        v-model="serch1"
                        >
                    </el-input>
                </div>
            </div>
            <div class="searchBtn" @click="searchCert">查询</div>
        </div>
      <div class="searchForm-1" v-if="isCert">
             <div class="enCert-bg">
            <div class="certBox-item-title">
                      {{list.title}}
              </div>
            <div class="certBox-item-content flex align-cen">
                        <div class="certBox-item-content-1">
                               {{list.content}}
                        </div>
                    </div>
                    <div class="certBox-flex flex">
                    <div class="certBox-item-info">
                         <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">证书专业:</div>
                                <div class="top-val">
                                    {{list.certMajor}}
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                                Certificate Major
                            </div>
                        </div>
                         <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">证书等级:</div>
                                <div class="top-val">
                                    {{list.certLevel}}
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                               Certificate Level
                            </div>
                        </div>
                          <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">证书编号:</div>
                                <div class="top-val">
                                    {{list.certificateNo}}
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                                Certificate Number
                            </div>
                        </div>
                           <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">发证机构:</div>
                                <div class="top-val top-val1">
                                    （盖章）
                                    <img 
                                    :src="list.institutionSignet"
                                     alt="" 
                                    class="top-val-img">
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                               Issuing Authority (Seal)
                            </div>
                        </div>
                           <div class="flex" >  
                             <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">发证日期:</div>
                                <div class="top-val">
                                    {{list.issueTime}}
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                              Date of Issue
                            </div>
                        </div>
                          <!-- <div class="certBox-item-info-item" style="margin-left:70px">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">发证机构负责人(签章):</div>
                                <div class="top-val2">
                                     <img 
                                      :src="`${list.principalSignet}?${new Date().getTime()}`"
                                      alt="" 
                                      crossOrigin="anonymous" 
                                     alt="" class="top-val-img1">
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                             Person in Charge of Issuing Authority
                            </div>
                        </div> -->
                        </div>
                            <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">查询网址:</div>
                                <div class="top-val top-val1 top-val3 flex align-cen">
                                     <vue-canvas-poster :widthPixels="70" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
                                     <div class="urldsiv">
                                        <!-- {{this.$config.prUrl + '#/webenterprise/enCert?id='+ seeId}}  -->
                                     </div>
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                               Website
                            </div>
                        </div>
                    </div>
                        <div class="mft certBox-flex-right">
                      <div class="certBox-item-content-2">
                            <img 
                             :src="list.pic"
                                >
                        </div>
                        <div class="certBox-flex-right-item flex">
                            <div class="right-label">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名:</div>
                            <div class="right-val">{{list.recipientName}}</div>
                        </div>
                         <div class="certBox-flex-right-item flex">
                            <div class="right-label">性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别:</div>
                            <div class="right-val">{{list.sex == 1 ? '男' : '女'}}</div>
                        </div>
                         <div class="certBox-flex-right-item flex">
                            <div class="right-label right-label1">出生年月:</div>
                            <div class="right-val right-val1">{{list.birthDate}}</div>
                        </div>
                    </div>
                    </div>
        </div>
        <div class="searchBtn" @click="isCert=false" style="margin-top:20px">返回查询</div>
        </div>
       
    </div>
</template>
<script>
import { getreceiveCert } from "@/api/enterprise/index" //证书查询
export default {
    name:'searchCert',
    data() {
        return {
            serch:'',
            serch1:'',
            list:{},
            isCert:false,
            painting: {
                    width: '70px',
                    height: '70px',
                    borderRadius:'0px',
                    views: [
                         {
                        type: 'qrcode',
                        content: '',
                        css: {
                            top: '0px',
                            left: '0px',
                            color: '#000',
                            width: '70px',
                            height: '70px'
                        }
                        },
                    ],
                },  
        }
    },
    created () {
        
    },
    methods: {
        // z证书查询
        searchCert(){
            if(!this.serch) return this.$util.Notifi('请输入证书编号','error','fa-exclamation-circle')
            if(!this.serch1) return this.$util.Notifi('请输入姓名查询','error','fa-exclamation-circle')
            getreceiveCert({
                name:this.serch1,
                certificateNo:this.serch
            })
            .then(res =>{
               this.isCert = true
               this.list = res.data[0]
              this.$nextTick(() =>{
                 this.painting.views[0].content = this.$config.prUrl + '#/webenterprise/mobileIndex?id='+ res.data[0].id
              })
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.searchCert{
    height: 970px;
    background: #f5f5f5;
    width: 100%;
    justify-content: center;
    .searchForm{
    .searchForm-item{
        padding-bottom: 20px;
        .label{
            width: 150px;
            text-align: right;
        }
    }
    }
        .searchBtn{
            width: 108px;
            height: 34px;
            background: #2893f1;
            color: #fff;
            border-radius: 5px;
            cursor: pointer;
            font-size: 14px;
            text-align: center;
            line-height: 34px;
            margin: 0 auto;
    }
   .enCert-bg{
       width:1069px;
        height: 803px;
        background: url("../../assets/images/certImg.jpg") no-repeat 0 0;
        background-size: 100% 100%;
        overflow: hidden;
        .certBox-item-title{
           text-align: center;
            font-size: 43px;
            padding-top: 128px;
            font-weight: bold;
            color: #000;
        }
         .certBox-item-content{
               padding: 0 154px;
               height: 150px;
                 .certBox-item-content-1{
                    width: 100%;
                    font-size: 20px;
                    line-height: 35.3px;
                    color: #000;
                    text-indent:45px;
                    text-align: justify;
                    margin-right: 29.8px;
                     display: -webkit-box;  
                    -webkit-line-clamp: 3;  
                    -webkit-box-orient: vertical;  
                    overflow: hidden;  
                    text-overflow: ellipsis; 
                }
                .certBox-item-content-2{
                    width: 109px;
                    height: 145px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                    .certBox-item-content-2-name{

                        font-size: 20px;
                        color: #000;
                        line-height: 30px;
                        letter-spacing: 5px;
                        text-align: center;
                        padding-top: 10px;

                        
                    }
                }
            }
                      .certBox-item-info{
               padding-left: 183px;
            .certBox-item-info-item{
                .certBox-item-info-item-top{
                    .top-label{
                         letter-spacing: 10px;
                        line-height: 28px;
                        color: #000000;
                        font-size: 16px;
                    }
                     .top-val{
                        width: 200px;
                        text-align: center;
                        font-size: 16px;
                        line-height: 28px;
                        color: #000000;
                        border-bottom: 2px solid #000;
                        position: relative;
                        .top-val-img{
                            width: 140px;
                            height: 140px;
                            border-radius: 50%;
                            position: absolute;
                            right: -50px; 
                            z-index: 999;
                        }
                       
                    }
                   .top-val2{
                        position: relative;
                          width: 100px;
                            height: 30px;
                         .top-val-img1{
                            width: 100px;
                            height: 30px;
                            position: absolute;
                        }
                    }
                    .top-val1{
                        border-bottom: none;
                        text-align: left;
                    }
                    .top-val3{
                        width: auto;
                        padding-left: 80px;
                        font-size: 13px;
                        position: relative;
                        .urldsiv{
                          position: absolute;
                            width: 600px;
                            top: 15px;
                        }
                    }
                }
                .certBox-item-info-item-bot{
                      font-size: 14px;
                    line-height: 26px;
                    font-style: italic;
                }
            }
            }
                    .certBox-flex-right{
                padding-right: 183px;
                 .certBox-item-content-2{
                    width: 109px;
                    height: 145px;
                    background: #fff;
                    margin: 0 auto;
                    margin-bottom: 20px;
                     img{
                        height: 100%;
                    }
                }
                .certBox-flex-right-item{
                    .right-label{
                        letter-spacing: 10px;
                        line-height: 35px;
                        color: #000000;
                        font-size: 16px;
                    }
                    .right-label1{
                        letter-spacing: 1px;
                    }
                    .right-val1{
                        margin-left: 8px;
                    }
                         .right-val{
                        width: 120px;
                        padding-left: 20px;
                        font-size: 16px;
                        line-height: 25px;
                        color: #000000;
                       position: relative;
                        position: relative;
                        
                    }
                    .right-val::after{
                        content:'' ;
                        position: absolute;
                        bottom: 5px;
                        left: 0;
                        width: 100%;
                        background: #000;
                         height: 2px;
                    }
                }
            }
    }

}
::v-deep{
     .canvas{
        position: absolute !important;
        left: 0vw;
        top: -1.5vh;
    }
     .inpt{
            width: 300px;
            .el-input{
                .el-input__inner{
                     background: transparent !important;
                }
               
            }
        }
}
</style>